let audioCtx = null;

const getAudioContext = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) audioCtx = new Ctx();
  if (audioCtx.state === 'suspended') audioCtx.resume().catch(() => {});
  return audioCtx;
};

// Mobile browsers (iOS Safari, Chrome Android) only allow creating/resuming an
// AudioContext from inside a real user-gesture event handler — a socket event
// arriving later doesn't count. Prime it on the first tap/click anywhere on the
// page so it's already running by the time a notification needs to play.
if (typeof window !== 'undefined') {
  const unlockAudio = () => {
    getAudioContext();
    window.removeEventListener('pointerdown', unlockAudio);
    window.removeEventListener('touchstart', unlockAudio);
  };
  window.addEventListener('pointerdown', unlockAudio, { once: true, passive: true });
  window.addEventListener('touchstart', unlockAudio, { once: true, passive: true });
}

const tone = (ctx, freq, startTime, duration, peakGain) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(peakGain, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startTime);
  osc.stop(startTime + duration);
};

// Short two-note "ding" — synthesized via Web Audio API so there's no audio
// asset to ship or fetch. Best-effort: browsers block sound before the user
// has interacted with the page at all, so a missed first play is expected.
export const playNotificationSound = () => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const now = ctx.currentTime;
    tone(ctx, 880, now, 0.16, 0.18);
    tone(ctx, 1175, now + 0.12, 0.22, 0.18);
  } catch (_) {
    // Never let a sound failure break the notification flow.
  }
};

export default playNotificationSound;
